import { createPortal } from 'react-dom';
import { Link } from 'react-router';

import { useBreadcrumbContext } from './use-breadcrumb-context';

import type { FC } from 'react';

interface BreadcrumbProps {
  label: string;
  to?: string;
  asLink?: boolean;
}

export const Breadcrumb: FC<BreadcrumbProps> = ({ label, to = '', asLink = true }) => {
  const [portalNode] = useBreadcrumbContext();
  return portalNode ? (
    <>
      {createPortal(
        <>
          <span className="first:hidden text-xs relative text-day-neutral-subtle opacity-80 px-1">
            {'\u276F'}
          </span>
          {asLink ? (
            <Link
              to={to}
              title={label}
              relative="path"
              className="cursor-pointer truncate border-transparent border-b-[3px] hover:border-b-[3px] hover:border-day-neutral-subtle hover:border-opacity-80 2xl:text-base text-sm opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-light-grey transition-colors duration-300 text-day-neutral-subtle"
            >
              {label}
            </Link>
          ) : (
            <span
              title={label}
              className="truncate 2xl:text-base text-sm opacity-80 text-day-neutral-subtle"
            >
              {label}
            </span>
          )}
        </>,
        portalNode,
      )}
    </>
  ) : null;
};
